<template>
  <v-container fluid class="mt-4">

    <v-row>
      <v-col cols="12"  align="center">
        <div class=" font-weight-black text-h4">¡Bienvenido {{getdatosUsuario.nomuser}}!</div>
      </v-col>
    </v-row>

    <!-- Abrir la caja -->
    <v-row align="center" justify="center" v-if="estatusCaja == false">
      <v-col cols="12" md="8" lg="6"  align="center">

        <v-card class="shadowCard">
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="denominaciones"
              :items-per-page="20"
              hide-default-footer
            >
              <template v-slot:item.cantidad="props">
                <v-edit-dialog
                  :return-value.sync="props.item.cantidad"
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                > {{ props.item.cantidad }}
                  <template v-slot:input>
                    <v-text-field
                      v-model="props.item.cantidad"
                      label="Edit"
                      single-line
                      type="number"
                      counter
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>
            </v-data-table>
            <div><h3>Saldo inicial {{saldoinicial}}</h3></div>
            <v-btn 
              tile
              small 
              block
              class="mr-6 mt-2" 
              color="primary" 
              @click="abrirCaja"
              v-if="estatusCaja == false"
            >
              Abrir caja
            </v-btn>
          </v-card-text>
        </v-card>

        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
          {{ snackText }}
          <template v-slot:action="{ attrs }">
            <v-btn v-bind="attrs" text @click="snack = false">Close</v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>

    <v-row align="center" justify="center" v-if="estatusCaja == true">
      <Caja/>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
    
  </v-container>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  // Componentes
  import Caja                  from '@/views/corte/Caja.vue'
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  // var moment  = require('moment');
  // moment.locale('es');

  export default {

    components:{
      Alerta,
      carga,
      Caja
    },

    mixins:[ validarErrores ],

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      estatusCaja:false,

      snackbar: false,
      color:'success',
      text:'',

      fecha: new Date().toISOString().substr(0, 10),
      usuarios:[],
      loading: 5,
      mensaje:'',

      snack: false,
      snackColor: '',
      snackText: '',
      saldoinicial:0,

      headers:[
        {text: 'Valor'       , value:'text'    },
        {text: 'Denomicación', value:'valor'   },
        {text: 'Cantidad'    , value:'cantidad'},
      ],

      denominaciones:[
        {text: 1000, valor:'mil'       , cantidad:0},
        {text: 500 , valor:'quinientos', cantidad:0},
        {text: 200 , valor:'doscientos', cantidad:0},
        {text: 100 , valor:'cien'      , cantidad:0},
        {text: 50  , valor:'cincuenta' , cantidad:0},
        {text: 20  , valor:'veinte'    , cantidad:0},
        {text: 10  , valor:'diez'      , cantidad:0},
        {text: 5   , valor:'cinco'     , cantidad:0},
        {text: 2   , valor:'dos'       , cantidad:0},
        {text: 1   , valor:'uno'       , cantidad:0},
        {text: .50 , valor:'cincuentac', cantidad:0},
        {text: .20 , valor:'veintec'   , cantidad:0},
        {text: .10 , valor:'diezc'     , cantidad:0},
      ],

      horainicial:'',
      fechainicial:'',
    }),

    computed:{
      ...mapGetters('login',['getdatosUsuario'])
    },

    created(){
      this.initialize()
    },

    methods:{

      ...mapActions('login',['getidCaja']),
      initialize () {
        // Saber si la caja esta abierta
        var payload = {
          idusuario: this.getdatosUsuario.id
        }
        
        this.$http.post('caja.abierta', payload).then(response=>{
          this.getidCaja(response.body[0].idcaja)
          this.$http.get('caja.get/' + response.body[0].idcaja).then(response=>{
            this.horainicial  = response.body.hora
            this.fechainicial = moment(response.body.fecha).format('LL');
            this.estatusCaja  = true
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      ver(value){
        console.log(value)
      },

      save () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved'
        // Inicializamos el saldo inicial en 0
        this.saldoinicial = 0
        // Hacemos un recorrido para saber cuanto dinero tiene la caja
        for(const i in this.denominaciones){
          this.saldoinicial += (this.denominaciones[i].text * this.denominaciones[i].cantidad)
        }
      },
      cancel () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      open () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      close () {
        console.log('Dialog closed')
      },
      hora(){
        var f =new Date();
        var hora = f.getHours()
        var minuto = f.getMinutes()
        var segundo = f.getSeconds()   
        if(hora < 10){
          hora = "0" + f.getHours()
        }
        if(minuto < 10){
          minuto = "0" + f.getMinutes() 
        }
        if(segundo < 10){
          segundo = "0" + f.getSeconds()
        }
        return hora + ":" + minuto + ":" + segundo
      },

      abrirCaja(){
        var caja = {
          fecha: this.fecha,
          hora: this.hora(),
          idusuario: this.getdatosUsuario.id,
          saldoinicial: this.saldoinicial,
        }
        // Abrir caja
        this.$http.post('abrir.caja', caja).then(response=>{
          this.getidCaja(response.body.id)
          var estatus = {
            idusuario: this.getdatosUsuario.id,
            idcaja: response.body.id
          }
          // Agregamos a la tabla el estatus de caja par saber que ya esta abierta su caja
          this.$http.post('add.estatus.caja', estatus).then(response=>{
            // Creamos las denominaciones que vamos a agregar
            var denominaciones = {
              idcaja: estatus.idcaja,
              mil: parseInt(this.denominaciones[0].cantidad),
              quinientos: parseInt(this.denominaciones[1].cantidad),
              doscientos: parseInt(this.denominaciones[2].cantidad),
              cien: parseInt(this.denominaciones[3].cantidad),
              cincuenta: parseInt(this.denominaciones[4].cantidad),
              veinte: parseInt(this.denominaciones[5].cantidad),
              diez: parseInt(this.denominaciones[6].cantidad),
              cinco: parseInt(this.denominaciones[7].cantidad),
              dos: parseInt(this.denominaciones[8].cantidad),
              uno: parseInt(this.denominaciones[9].cantidad),
              cincuentac: parseInt(this.denominaciones[10].cantidad),
              veintec: parseInt(this.denominaciones[11].cantidad),
              diezc: parseInt(this.denominaciones[12].cantidad),
            }
            // agregamos las denominaciones a la caja
            this.$http.post('denominaciones', denominaciones).then(response=>{
              this.color = 'success'
              this.text = 'Caja creada correctamente'
              this.snackbar = 'true'
              this.estatusCaja = true
              console.log(response)
            }).catch(error=>{
              console.log(error)
              this.caputadeError(error.body.message)
            })
          }).catch(error=>{
            console.log(error)
            this.caputadeError(error.body.message)
          })
        }).catch(error=>{
          console.log(error)
          this.caputadeError(error.body.message)
        })
      },

      caputadeError(value){
        this.color = 'error'
        this.text = value
        this.snackbar = true
      } 

    }
  }

</script>

<style scoped>
  .padre{
    background: #11437C;  
    background: -webkit-linear-gradient(to right, #11437C, #12608D, #00B7D0);  
    background: linear-gradient(to right, #11437C, #12608D, #00B7D0);

    align-items: center;
  }

  .hijo{
    font-size: calc(1em + 1vw);
    font-family: 'Times New Roman' !important;
  }
</style>

